<template>
<div>
  <v-dialog v-model="dialog" max-width="500px">
  <v-card>
  <v-card-title>
    <span class="headline">Upozorenje! Operater nema upisan OIB</span>
  </v-card-title>
  <v-card-text>
    <v-container>
      <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <span class="headline">Molim upišite OIB. Please enter user VATID</span>
      </v-col>
    </v-row>
      <v-row dense>
        <v-col cols="12" sm="4" md="4" lg="4" xl="4">
          <v-text-field
            :label="lang.First"
            v-model="editedItem.First"
            outlined
            disabled
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="4" lg="4" xl="4">
          <v-text-field
            :label="lang.Last"
            v-model="editedItem.Last"
            outlined
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>             
        <v-col cols="12" sm="8" md="8" lg="8" xl="8">
          <v-text-field
            :label="lang.VATID"
            v-model="editedItem.vatID"
            outlined
            autofocus
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>             
        <v-col cols="12" sm="8" md="8" lg="8" xl="8">
          <small>Nakon upisa OIBa, Roboot će vas odlogirati. Morate se ponovno logirati.</small>
        </v-col>
      </v-row>
      <v-row dense>             
        <v-col cols="12" sm="8" md="8" lg="8" xl="8">
          <small>After VATid enter, Roboot will logout you. Please loginin again.</small>
        </v-col>
      </v-row>

      <v-row>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close" class="mr-2">{{langC.Cancel}}</v-btn>
        <span>
          <v-btn color="success" text @click="save">{{langC.Save}}</v-btn> 
        </span>
      </v-row>
      </v-container>
    </v-card-text>
  </v-card>
  </v-dialog> 
  <v-progress-circular
      v-if="this.saving"
      indeterminate
      color="green"
    ></v-progress-circular>
  </div>
</template>

<script>
import UserService from '@/services/UserService'
import langEn from './userDescEn'
import langHr from './userDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"

  export default {
    name: 'userupdatevatid',
    data: () => ({
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal2: false,
      menu2: false,
      lang: {},
      langC: {},
      saving: false,
      error: null,
      errorMatch: null,
      modal: false,
      show1: false,
      show2: false,
      headAdmin: false,
      changePass: false,
      mainQuery: {
        CompanyId: 1,
        businessYear: 0,
        documentName: "",
        databaseDocID: 0
      },
      dialog: true,
      headers: [
        
      ],
      editedItem: { }
    }),

    computed: {

    },

    watch: {

    },
    components: {
    
    },

    mounted() {
      if (this.$store.state.language === "EN") {
        this.lang = langEn
        this.langC = commEn;
      }
      if (this.$store.state.language === "HR") {
        this.lang = langHr
        this.langC = commHr;
      }
      if (this.$store.state.companyid) {
        this.mainQuery.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.businessYear) {
        this.mainQuery.businessYear = this.$store.state.businessYear
      }

    },

    created () {
      this.initialize()
    },

    methods: {
      close() {
        this.dialog = false
      },
      changePassword() {
        this.changePass = !this.changePass
      },
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      async initialize () {
        try {
          this.saving = true
          this.editedItem = (await UserService.show(this.$store.state.user.id)).data.user       
          this.saving = false
        } catch (err) {
          this.error = err
          
        }
      },

      async save () {
        try {
          await UserService.put(this.editedItem)
          this.dialog = false
          this.logout()
        } catch(err) {
          this.error = err
        }
       
      },
      logout () {
        this.showLogOut = false
        this.$store.dispatch('setBusinessYear', null)
        this.$store.dispatch('setCompanyName', null)
        this.$store.dispatch('setCompanyid', null)
        this.$store.dispatch('setCompanyActiv', null)
        this.$store.dispatch('setToken', null)
        this.$store.dispatch('setUser', null)
        this.$store.dispatch('isUserLoggedIn', false)
        this.$store.dispatch('setDateItems', null)
        this.$store.dispatch('setDatePartners', null)
        this.$store.dispatch('setDateAccounts', null)
        this.$router.push({
          path: '/'
        }).catch(err => {
            // eslint-disable-next-line
            console.log(err);
          })
      },
    },
  }
</script>